<template>
  <v-layout>
    <async-data :request-state="requestState">
      <div v-if="caseDetails"> <!--todo: use scoped slot -->
        <table>
          <tr>
            <td class="case-param-name"><strong>Status</strong></td>
            <td>
              <strong>{{caseDetails.status}}</strong>
            </td>
          </tr>

          <tr>
            <td class="case-param-name"><strong>DpId</strong></td>
            <td>
              {{caseDetails.dpId}}
            </td>
          </tr>

          <tr>
            <td class="case-param-name"><strong>Client</strong></td>
            <td>
              <client-short-info :client-id="caseDetails.clientId"/>
            </td>
          </tr>

          <tr>
            <td><strong>Case creation date</strong></td>
            <td><span>{{ caseDetails.creationDatetime | DateWithMinutes | NoEmpty}}</span></td>
          </tr>

          <tr>
            <td><strong>Report validation ended date</strong></td>
            <td><span>{{ caseDetails.reportValidationEndedDate | DateWithMinutes | NoEmpty}}</span></td>
          </tr>

          <tr>
            <td><strong>Overridden report validation ended date</strong></td>
            <td>
              <overridden-report-validation-ended-date-input
                :case-id="caseDetails.id"
                :original-value="caseDetails.reportValidationEndedDate"
                v-model="caseDetails.overrideInfo.overriddenReportValidationEndedDate"/>
            </td>
          </tr>

          <tr>
            <td><strong>Period Execution</strong></td>
            <td><span>{{ caseDetails.periodExecution }}</span></td>
          </tr>

          <tr>
            <td><strong>Materials receiving date</strong></td>
            <td><span>{{ caseDetails.overriddenReceiptMaterialsDatetime | DateWithMinutes | NoEmpty}}</span></td>
          </tr>

          <tr>
            <td><strong>Overridden materials receiving date</strong></td>
            <td>
              <overridden-receipt-materials-datetime-input
                :case-id="caseDetails.id"
                :original-value="caseDetails.overriddenReceiptMaterialsDatetime"
                v-model="caseDetails.overrideInfo.overriddenReceiptMaterialsDatetime"/>
            </td>
          </tr>

          <tr>
            <td><strong>Patient name</strong></td>
            <td><span>{{ caseDetails.patientName  | NoEmpty}}</span></td>
          </tr>

          <tr>
            <td><strong>Incoming Raw Material</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'incomingRawMaterials') }}</span></td>
          </tr>
          <tr>
            <td><strong>Slides created from incoming histoblocks</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'slidesCreatedFromIncomingHistoblocks') }}</span></td>
          </tr>
          <tr>
            <td><strong>Incoming histoblocks registered</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'incomingHistoblocksRegistered') }}</span></td>
          </tr>
          <tr>
            <td><strong>Incoming Slides Scanned</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'incomingSlidesScanned') }}</span></td>
          </tr>
          <tr>
            <td><strong>Incoming Slides Created</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'incomingSlidesCreated') }}</span></td>
          </tr>
          <tr>
            <td><strong>New Histoblock Created</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'newHistoblockCreated') }}</span></td>
          </tr>
          <tr>
            <td><strong>New IHC Slides Created</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'ihcSlidesCreated') }}</span></td>
          </tr>
          <tr>
            <td><strong>New HC Slides Created</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'hcSlidesCreated') }}</span></td>
          </tr>
          <tr>
            <td><strong>New H&E Slides Created</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'heSlidesCreated') }}</span></td>
          </tr>
          <tr>
            <td><strong>New IHC Slides Scanned</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'ihcSlidesScanned') }}</span></td>
          </tr>
          <tr>
            <td><strong>New HC Slides Scanned</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'hcSlidesScanned') }}</span></td>
          </tr>
          <tr>
            <td><strong>New H&E Slides Scanned</strong></td>
            <td><span>{{ getItemDataByPath(caseDetails, 'heSlidesScanned') }}</span></td>
          </tr>
        </table>
      </div>
    </async-data>
    <dev-mode>
      <ReCalculateCaseAnomaliesForm :case-id="caseId"/>
      <UpdateCaseServicesInfoForm :case-id="caseId"/>
    </dev-mode>
  </v-layout>
</template>

<script>
  import {mapActions} from 'vuex';
  import AsyncData from "../../components/Ui/AsyncData";
  import DateWithMinutes from '../Filters/DateWithMinutes';
  import NoEmpty from '../Filters/NoEmpty';
  import ClientShortInfo from "../../components/Ui/mcc/ClientShortInfo";
  import {RequestState} from '../../requestState';
  import OverriddenReceiptMaterialsDatetimeInput from './OverriddenReceiptMaterialsDatetimeInput';
  import OverriddenReportValidationEndedDateInput from './OverriddenReportValidationEndedDateInput';
  import ReCalculateCaseAnomaliesForm from "../case-anomalies/ReCalculateCaseAnomaliesForm";
  import UpdateCaseServicesInfoForm from "../analytics/UpdateCaseServicesInfoForm";
  import DevMode from "../Ui/DevMode";

  export default {
    name: 'case-info',
    components: {
      AsyncData,
      ClientShortInfo,
      OverriddenReceiptMaterialsDatetimeInput,
      OverriddenReportValidationEndedDateInput,
      ReCalculateCaseAnomaliesForm,
      UpdateCaseServicesInfoForm,
      DevMode
    },
    filters: {
      DateWithMinutes,
      NoEmpty
    },
    props: {
      caseId: {
        type: String,
        required: true
      }
    },
    data() {
      return {}
    },
    computed: {
      caseInfo() {
        return this.$store.getters.getCaseInfoById(this.caseId)
      },
      requestState() {
        if (!this.caseInfo) {
          return RequestState.NotPerformed
        }

        return this.caseInfo.requestState
      },
      caseDetails() {
        if (!this.caseInfo) {
          return null
        }

        return this.caseInfo.response || null
      },
      fetchDPUrl() {
        return this.$store.state.dpURL
      }
    },
    mounted() {
      this.fetchCaseByIdIfRequired(this.$route.params.caseId)
    },
    methods: {
      ...mapActions({
        fetchCaseByIdIfRequired: 'fetchCaseByIdIfRequired'
      }),
      buildDPCaseUrl(dpCaseId) {
        return `${this.fetchDPUrl}cases/${dpCaseId}`
      },
      getItemDataByPath(item, path) {
        return _.get(item, path, '-')
      },
    }
  }
</script>

<style scoped>
  .case-param-name {
    min-width: 320px;
  }
</style>



// WEBPACK FOOTER //
// src/components/case/CaseInfo.vue